import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeviceStateConfigComponent } from './device-state-config.component';

const routes: Routes = [
  {
    path: 'device-state-config',
    data: { name: 'Device State Config', isTab: false },
    component: DeviceStateConfigComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceStateConfigPageRoutingModule {}
